import { __extends } from "tslib";
import { ASObject } from "../nat/ASObject";
import { addPrototypeFunctionAlias } from "../nat/addPrototypeFunctionAlias";
import { assert } from "@awayjs/graphics";
import { release } from "@awayfl/swf-loader";
/*
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * TODO: We need a more robust Dictionary implementation that doesn't only give you back
 * string keys when enumerating.
 */
var Dictionary = /** @class */ (function (_super) {
    __extends(Dictionary, _super);
    function Dictionary(weakKeys) {
        if (weakKeys === void 0) { weakKeys = false; }
        var _this = _super.call(this) || this;
        _this.map = new WeakMap();
        _this.keys = null;
        _this.weakKeys = !!weakKeys;
        if (!weakKeys) {
            _this.keys = [];
        }
        _this.primitiveMap = Object.create(null);
        return _this;
    }
    Dictionary.makePrimitiveKey = function (key) {
        if (typeof key === "string" || typeof key === "number") {
            return key;
        }
        release || assert(typeof key === "object" || typeof key === "function", typeof key);
        return undefined;
    };
    Dictionary.prototype.toJSON = function () {
        return "Dictionary";
    };
    Dictionary.prototype.axGetProperty = function (mn) {
        if (this === this.axClass.dPrototype) {
            return _super.prototype.axGetProperty.call(this, mn);
        }
        var key = Dictionary.makePrimitiveKey(mn.name);
        if (key !== undefined) {
            return this.primitiveMap[key];
        }
        return this.map.get(Object(mn.name));
    };
    Dictionary.prototype.axSetProperty = function (mn, value, bc) {
        if (this === this.axClass.dPrototype) {
            _super.prototype.axSetProperty.call(this, mn, value, bc);
            return;
        }
        var key = Dictionary.makePrimitiveKey(mn.name);
        if (key !== undefined) {
            this.primitiveMap[key] = value;
            return;
        }
        this.map.set(Object(mn.name), value);
        if (!this.weakKeys && this.keys.indexOf(mn.name) < 0) {
            this.keys.push(mn.name);
        }
    };
    // TODO: Not implemented yet.
    // public axCallProperty(mn: Multiname, args: any []) {
    //   release || release || notImplemented("axCallProperty");
    // }
    Dictionary.prototype.axHasPropertyInternal = function (mn) {
        if (this === this.axClass.dPrototype) {
            return _super.prototype.axHasProperty.call(this, mn);
        }
        var key = Dictionary.makePrimitiveKey(mn.name);
        if (key !== undefined) {
            return key in this.primitiveMap;
        }
        return this.map.has(Object(mn.name));
    };
    Dictionary.prototype.axDeleteProperty = function (mn) {
        if (this === this.axClass.dPrototype) {
            return _super.prototype.axDeleteProperty.call(this, mn);
        }
        var key = Dictionary.makePrimitiveKey(mn.name);
        if (key !== undefined) {
            delete this.primitiveMap[key];
        }
        this.map.delete(Object(mn.name));
        var i;
        if (!this.weakKeys && (i = this.keys.indexOf(mn.name)) >= 0) {
            this.keys.splice(i, 1);
        }
        return true;
    };
    Dictionary.prototype.axGetPublicProperty = function (nm) {
        if (this === this.axClass.dPrototype) {
            return _super.prototype.axGetPublicProperty.call(this, nm);
        }
        var key = Dictionary.makePrimitiveKey(nm);
        if (key !== undefined) {
            return this.primitiveMap[key];
        }
        return this.map.get(Object(nm));
    };
    Dictionary.prototype.axGetEnumerableKeys = function () {
        if (this === this.axClass.dPrototype) {
            return _super.prototype.axGetEnumerableKeys.call(this);
        }
        var primitiveMapKeys = [];
        for (var k in this.primitiveMap) {
            primitiveMapKeys.push(k);
        }
        if (this.weakKeys) {
            // TODO implement workaround for flashx.textLayout.external.WeakRef
            return primitiveMapKeys; // assuming all weak ref objects are gone
        }
        if (this.keys) {
            return primitiveMapKeys.concat(this.keys);
        }
        return primitiveMapKeys.slice();
    };
    Dictionary.classInitializer = function () {
        var proto = this.dPrototype;
        var asProto = Dictionary.prototype;
        addPrototypeFunctionAlias(proto, '$BgtoJSON', asProto.toJSON);
    };
    return Dictionary;
}(ASObject));
export { Dictionary };
